import snackbar, { types } from './store/snackbar';
import VueSnackbar from './components/VueSnackbar.vue';

export default {
  install(Vue, { store, defaultOptions = {} }) {
    if (!store) {
      throw new Error('Snackbar requires Vuex store.');
    }
    store.registerModule('snackbar', snackbar);
    store.commit(`snackbar/${types.SNACKBAR_DEFAULT}`, defaultOptions);
    Vue.prototype.$snackbar = {
      show(message, options = {}) {
        store.dispatch('snackbar/show', { message, options });
      },
      hide() {
        store.dispatch('snackbar/hide');
      },
    };
    Vue.component('vue-snackbar', VueSnackbar);
  },
};
